import { ReceituarioResponseStatus, ReceituarioResponseTipo } from '@/api/generated/model';

/**
 * Rótulos do receituário.
 *
 * ⚠️ O status NÃO decide se dá para editar. Quem decide é `editavel`, que o
 * servidor devolve já pesando assinatura e cancelamento. Derivar na tela seria
 * uma segunda regra para divergir da primeira.
 */
export const STATUS = Object.values(ReceituarioResponseStatus);

export const ROTULO_STATUS: Record<string, string> = {
  RASCUNHO: 'Rascunho',
  ASSINADO: 'Assinado',
  CANCELADO: 'Cancelado',
};

export const CLASSE_STATUS: Record<string, string> = {
  RASCUNHO: '',
  ASSINADO: 'text-emerald-600 border-emerald-600/40',
  CANCELADO: 'text-destructive border-destructive/40',
};

export const TIPOS = Object.values(ReceituarioResponseTipo);

export const ROTULO_TIPO: Record<string, string> = {
  SIMPLES: 'Simples',
  CONTROLE_ESPECIAL: 'Controle especial',
};
